<template>
  <v-tooltip top v-if="oferta.destaque">
    <template v-slot:activator="{ on }">
      <v-icon small v-on="on" color="secondary">mdi-tag</v-icon>
    </template>
    <span>Oferta em destaque</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    oferta: Object,
  },
};
</script>
